import { Capacitor } from '@capacitor/core';
//import { SafeArea } from 'capacitor-plugin-safe-area';

export const configureSafeAreaInsets = async () => {
    if (Capacitor.isNativePlatform()) {
        // if (Capacitor.getPlatform() === 'ios') {
        //     const { insets } = await SafeArea.getSafeAreaInsets();
        //     for (const [key, value] of Object.entries(insets)) {
        //         document.documentElement.style.setProperty(`--safe-area-${key}`, `${value}px`);
        //     }
        // }
    }
};
